import { PillTextbox } from '../types';
import { resizePillToFit } from './resize-pill';

// In-memory marker, not serialized.
const ATTACHED_KEY = '__pillListenerAttached';

type MarkedPill = PillTextbox & { [ATTACHED_KEY]?: boolean };

/**
 * Bakes corner scaling into the pill metrics, then resets Fabric scale.
 * The text fit recalculates width, so vertical scale drives the final size.
 */
function applyPillScale(pill: PillTextbox): void {
  const sx = pill.scaleX ?? 1;
  const sy = pill.scaleY ?? 1;
  if (sx === 1 && sy === 1) return;

  const ratio = sy;
  const meta = pill.pill;
  pill.set('fontSize', (pill.fontSize ?? 0) * ratio);
  meta.paddingX *= ratio;
  meta.paddingY *= ratio;
  meta.borderRadius *= ratio;
  meta.strokeWidth *= ratio;
  meta.minWidth *= ratio;
  if (meta.paddingLeft !== undefined) meta.paddingLeft *= ratio;
  if (meta.paddingRight !== undefined) meta.paddingRight *= ratio;
  if (meta.icon) {
    meta.icon.width *= ratio;
    meta.icon.height *= ratio;
    meta.icon.gap *= ratio;
  }
  pill.set({ scaleX: 1, scaleY: 1 });
}

// Use only corner resize handles to avoid stretching the pill from the sides.
const PILL_CONTROLS_VISIBILITY = { ml: false, mr: false, mt: false, mb: false };

export function initPill(pill: PillTextbox): void {
  const marked = pill as MarkedPill;
  if (marked[ATTACHED_KEY]) return;
  marked[ATTACHED_KEY] = true;
  pill.setControlsVisibility(PILL_CONTROLS_VISIBILITY);

  // Re-fit while typing, and bake scale before re-fitting after resize.
  pill.on('changed', () => resizePillToFit(pill));
  pill.on('modified', () => {
    applyPillScale(pill);
    resizePillToFit(pill);
  });
}
